import PropTypes from 'prop-types';
import React     from 'react';

// import { Legal } from '../../../common/legal';
// import { Price } from '../../../common/product/price';
// import { RemainingTime } from '../../../common/product/remaining-time';
// import { Expiry } from '../../../common/product/expiry';
// import { SimpActive }            from './simp-active';
// import { SimpCancelled }         from './simp-cancelled';
// import { SimpMobile }            from './simp-mobile';
// import { CancelledBox }          from '../../../common/product/cancelled-box';
// import { ProductName }           from '../../../common/product/prod-name';
// import { TagLine }               from '../../../common/product/tag-line';
import { useGlobalCtx }          from '../../../../context/ctx-hook';
import * as ProductSelectors     from '../../../../context/selectors/product-selectors';
import { getUserSubHistory }     from '../../../../context/selectors/user-selectors';
import { daysLeft, isInBetween } from '../../../../helpers/time-helpers';
import { getSimpPriceWarning }   from '../../../../helpers/skunotices-helpers';
// import * as RouteHelpers from '../../../../helpers/route-helper';

import { setCtxNestedObj } from '../../../../context/ctx-actions';
// import { useGlobalCtx } from '../../../../context/ctx-hook';
// import { setCtxNestedObj } from '../../../../context/ctx-actions';
// import { useGlobalCtx } from '../../../../context/ctx-hook';
import { getProductsPaymentMethod } from '../../../../context/selectors/user-selectors';
import { useAutoRenew } from '../../../../helpers/hooks/use-auto-renew';
import * as StateConstants from '../../../../helpers/constants/state-constants';
// import { getSimpPriceWarning } from '../../../../helpers/skunotices-helpers';
import { CancelDowngradeBox } from '../../../modals/change-plans/cancel-downgrade';
import { SingleProductRow } from '../unified-sub-tile/product-single-row';

import * as S from './simp-tile.module.scss';

const PRODUCT = 'acme';
// const annualSku = '170522';


const getAccountMsg = ({ active, autoRenew }, hasPayment) => {
  if (!active) {
    return {
      title: 'Expired Subscription',
      message: 'This subscription is no longer active',
    };
  } else if (!hasPayment) {
    return {
      title: 'No Payment Method',
      message: 'In order to not lose your connected services, add a payment method for renewal'
    };
  } else if (!autoRenew) {
    return {
      title: 'Renewal Canceled',
      message: 'Your subscription has been canceled but it is still valid until your expiration date. In order to avoid expiration, you must resume your subscription.'
    };
  } else {
    return false;
  }
};

const SimpTile = ({isModal, product }) => {
  const { state, globalDispatch }      = useGlobalCtx();
  const SUB          = ProductSelectors.getSubscription(state, product);
  const HISTORY_LIST = getUserSubHistory(state, product);
  const IS_MOBILE    = product !== 'acme';
  const { sku, renewalSku, renewalFrequency, expireOn, active, autoRenew, isInTrialPeriod, isCancelled } = SUB;
  const handleArOn    = useAutoRenew(PRODUCT, true);
  const HAS_PAYMENT   = getProductsPaymentMethod(PRODUCT, state);
  const MESSAGE = getAccountMsg({ active, autoRenew }, getProductsPaymentMethod(PRODUCT, state));
  const PENDING_DOWNGRADE = SUB?.renewalTierUriName ? SUB?.renewalTierUriName !== SUB?.tierUriName : false;
  const buyNowSku = state.skus?.[renewalSku] ? renewalSku : state.defaultSkus?.[state.country]?.[SUB?.tierUriName];

  const manageSubscription = React.useCallback(
    async () => globalDispatch(setCtxNestedObj('modal', {
      type:       StateConstants.MODALS.SUBSCRIPTION,
      ctx:        {product: [SUB]},
      isLoading:  true,
      hasError:   false,
      isDisabled: false
    })),
    [globalDispatch]
  );

  const updatePaymentModal = React.useCallback(
    () => globalDispatch(setCtxNestedObj('modal', {
      type:       StateConstants.MODALS.UPDATE_PAYMENT,
      ctx:        { product: PRODUCT, paymentOnly: false, isDefaultPayment: true },
      isLoading:  true,
      hasError:   false,
      isDisabled: false
    })),
    [globalDispatch]
  );

  const IS_CANCELLED = React.useMemo(
    () =>
      !SUB.active || (!SUB.autoRenew && HISTORY_LIST?.filter(({action, createdAt}) =>
        (action === 'DISABLE_AUTORENEW' && isInBetween(SUB.effectiveAt, SUB.expireOn, createdAt))
      ).length > 0),
    [SUB.autoRenew, SUB.effectiveAt, SUB.expireOn, HISTORY_LIST]
  );

  const DAYS_LEFT = React.useMemo(
    () => daysLeft(SUB.expireOn),
    [SUB.expireOn]
  );

  const { HAS_PRICE_WARNING, NEW_PRICE } = getSimpPriceWarning(sku, expireOn, state.featureFlags);

  const HAS_ADDONS = false;

  return (
    <div className={`${S.simpTile}`}>
      <SingleProductRow sub={SUB} testId={'ACME'}/>
    </div>
  );
};

SimpTile.displayName  = 'SimpTile';
SimpTile.propTypes    = {
  isModal: PropTypes.bool,
  product: PropTypes.string.isRequired
};
SimpTile.defaultProps = {isModal: false};

export { SimpTile };
